import { MDBBtn, MDBCol, MDBRow, MDBTypography } from 'mdbreact';
import React from 'react';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Header.scss";
import Back from "./../../../assets/images/back/webviewmobile.png"

const Header = (props: HeaderProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary
    );

    return <MDBRow className="header">
        <MDBCol md="5" className="brand-name" >
            <h1>{dictionary?.homepage?.tala_full_name}</h1>
            <h4>{dictionary?.homepage?.The_best_makeup_artists_are_just_a_click_away}</h4>
            <MDBBtn color="pink" size="sm">{dictionary?.share?.request_now_female}</MDBBtn>
        </MDBCol>
        <MDBCol md="7" className="brand-image">
            <img src={Back} alt="Back" />
        </MDBCol>
    </MDBRow>
};

interface HeaderProps { }
export default Header;